const theme = {
  brand: '#0D2249',
  primary: '#515358',
  secondary: '#A4A4A4',
  third: '#D8D8D8',
  fourth: '#E7E7E7',
  fifth: '#F9F9F9',
  base: '#FFFFFF',
  background: '#EEF4F9',

  colors: [
    '#D54D4D',
    '#1D73BC',
    '#4E8B08',
    '#118FC1',
    '#DDD026',
    '#11B136',
    '#595B5F',
  ],
};

export default theme;
